import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContactContext, useUserData } from "@/contexts/contact";
import { useContactingTestId } from "@/hooks";
import { useI18n, useIsNewBuildProject } from "@/shared/hooks";
import { PROFILE_STATUS } from "@/types";
import { getFeaturesEnabled } from "@/utils";
import { Box } from "@gemini/core";
import { Toggle } from "@gemini/ui";
import { Controller } from "react-hook-form";
import { UserInfos } from "./UserInfos";
export const ShareProfile = () => {
    const { t } = useI18n();
    const userData = useUserData();
    const testId = useContactingTestId("ContactForm.SeekerProfile.ShareProfile");
    const { enableShareSeekerProfile, userInfoComplete } = useContactContext();
    const { authentication } = getFeaturesEnabled();
    const isProject = useIsNewBuildProject();
    const showUserInfo = userInfoComplete && authentication && enableShareSeekerProfile;
    if ((userData === null || userData === void 0 ? void 0 : userData.profileStatus) !== PROFILE_STATUS.SHAREABLE ||
        !authentication ||
        !enableShareSeekerProfile ||
        isProject)
        return null;
    return (_jsxs(Box, { backgroundColor: "color.surface.light.default", borderRadius: "radius.16", marginTop: "spacing.16", display: "flex", flexDirection: "column", justifyContent: "space-between", testId: testId, children: [_jsxs(Box, { display: "flex", flexDirection: "row", paddingVertical: "spacing.8", paddingHorizontal: "spacing.16", width: "100%", justifyContent: "space-between", alignItems: "center", children: [_jsx(Box, { typography: "typography.body.16.bold", children: t("contact.form.seeker_profile.share.title") }), _jsx(Box, { children: _jsx(Controller, { name: "shareSeekerProfile", defaultValue: true, render: ({ field: { value, onChange, name } }) => (_jsx(Toggle, { hasNecessityIndicator: false, onChange: onChange, name: name, isSelected: value, children: " " })) }) })] }), showUserInfo && _jsx(UserInfos, {})] }));
};
